const ROLE_LABELS = {
  super_admin: 'Super Admin',
  dept_admin: 'Admin',
  dept_user: 'User'
};

const ROLE_PRIORITY = [
  'super_admin',
  'dept_admin',
  'dept_user'
];

export function normalizeRoles(roles = []) {
  if (!Array.isArray(roles)) return [];

  return roles
    .map((role) => {
      if (typeof role === 'string') {
        return { code: role, name: ROLE_LABELS[role] || role };
      }
      if (role && typeof role === 'object') {
        const code = String(role.code || role.id || '').trim();
        const name = String(role.name || ROLE_LABELS[code] || code || '').trim();
        return { code, name };
      }
      return { code: '', name: '' };
    })
    .filter((role) => role.code || role.name);
}

/**
 * users.name is often stored as "Last First" — display as "First Last" for two-part names.
 */
export function formatUserDisplayName(name = '', email = '') {
  const raw = String(name || '').trim();
  if (!raw) return email || 'Account';

  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length === 2) {
    return `${parts[1]} ${parts[0]}`;
  }
  return raw;
}

export function getInitials(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('') || '?';
}

export function resolvePrimaryRoleLabel(roles = []) {
  const normalized = normalizeRoles(roles);
  const matchCode = ROLE_PRIORITY.find((code) =>
    normalized.some((role) => role.code === code)
  );

  if (matchCode) {
    const role = normalized.find((item) => item.code === matchCode);
    return role?.name || ROLE_LABELS[matchCode] || matchCode;
  }

  return normalized[0]?.name || null;
}
